import { createFileRoute } from '@tanstack/react-router'
import { CookiesPage } from '@/components/pages/cookies-page'

export const Route = createFileRoute('/cookies')({
  component: CookiesPage,
  head: () => ({ meta: [{ title: 'Cookie policy — mkdn.app' }] }),
})
